import React from 'react';
import { string } from 'prop-types';
import { TextUtilities } from '@pwc/pwc-deals-web-common';

import { useSelector } from 'react-redux';
import { USER_TYPE_CLASSES } from 'common/constants/General';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';

import './UserSnippet.scss';

const UserSnippet = ({ dataTestId, firstName, lastName, position }) => {
  const userRole = useSelector(getUserRole);
  const userTypeClass = USER_TYPE_CLASSES[userRole] || '';
  return (
    <div className="usersnippet-container" data-testid={dataTestId}>
      <div
        className={`usersnippet-photo ${userTypeClass}`}
        data-testid={`${dataTestId}-initials`}
      >
        {TextUtilities.getUserInitials(firstName, lastName)}
      </div>
      <div className="usersnippet-text">
        <div className="usersnippet-name">{`${firstName} ${lastName}`}</div>
        <div className="usersnippet-position">{position}</div>
      </div>
    </div>
  );
};

UserSnippet.propTypes = {
  firstName: string,
  lastName: string,
  dataTestId: string,
};

UserSnippet.defaultProps = {
  firstName: '',
  lastName: '',
  dataTestId: 'user-snippet',
};

export default UserSnippet;
